export const GET_MARKUP_DEDUCT_PERCENTAGE = 'GET_MARKUP_DEDUCT_PERCENTAGE';
export const POST_MARKUP_DEDUCT_PERCENTAGE = 'POST_MARKUP_DEDUCT_PERCENTAGE';
export const SET_MARKUP_DEDUCT_PERCENTAGE = 'SET_MARKUP_DEDUCT_PERCENTAGE';
export const DATA_UPDATED = 'DATA_UPDATED';
export const GET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE =
  'GET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE';
export const SET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE =
  'SET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE';
export const GET_GOLD_SILVER_PRICE = 'GET_GOLD_SILVER_PRICE';
export const SET_GOLD_SILVER_PRICE = 'SET_GOLD_SILVER_PRICE';
export const SET_UPDATED_LIVE_QUOTES_PRICE = 'SET_UPDATED_LIVE_QUOTES_PRICE';
export const CHANGE_MARKUP_STATUS = 'CHANGE_MARKUP_STATUS';
